import React, { useState } from 'react';
import { Button, IconButton, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import WorkerService from '../../../services/worker';
import { CODES } from '../../../utils/codesHTTP';

const WorkerClockSearch = () => {
    const [search, setSearch] = useState('');
    const [workers, setWorkers] = useState([]);
    const [searched, setSearched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const searchWorkers = async (event) => {
        event.preventDefault();
        const query = search.trim();
        if (!query) {
            setWorkers([]);
            setSearched(false);
            setError('Ingrese un nombre, DNI o código SGH.');
            return;
        }

        try {
            setLoading(true);
            setSearched(true);
            setError('');
            const result = await WorkerService.getWorkerClocks(query);
            if (result.status === CODES.SUCCESS_200) {
                setWorkers(Array.isArray(result.data) ? result.data : []);
            } else {
                setWorkers([]);
                setError(result?.response?.data?.message || result?.data?.message || 'No fue posible realizar la búsqueda.');
            }
        } catch (requestError) {
            setWorkers([]);
            setError('No fue posible realizar la búsqueda.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid px-0">
            <form className="row g-2 justify-content-center mb-3" onSubmit={searchWorkers}>
                <div className="col-12 col-md-8 col-lg-7">
                    <TextField
                        fullWidth
                        size="small"
                        label="Nombre, DNI o código SGH"
                        placeholder="Ej. 88888888"
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                        InputProps={{
                            endAdornment: (
                                <IconButton type="submit" aria-label="Buscar trabajadores" edge="end">
                                    <SearchIcon />
                                </IconButton>
                            ),
                        }}
                    />
                </div>
                <div className="col-auto">
                    <Button type="submit" variant="contained" startIcon={<SearchIcon />} disabled={loading}>
                        {loading ? 'Buscando...' : 'Buscar'}
                    </Button>
                </div>
            </form>

            <div className="row justify-content-center">
                <div className="col-10 col-sm-10 col-md-9">
                    {error && <div className="alert alert-danger py-2" role="alert">{error}</div>}
                    {loading && <div className="text-center py-3">Buscando trabajadores...</div>}
                    {!loading && searched && !error && workers.length === 0 && (
                        <div className="alert alert-info py-2" role="status">No se encontraron trabajadores.</div>
                    )}

                    <div className="d-flex flex-column gap-3">
                        {workers.map((worker, workerIndex) => (
                            <section className="card shadow-sm" key={worker.id_persona || workerIndex}>
                                <div className="card-body p-3">
                            <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-2">
                                <div>
                                    <h6 className="mb-1">{worker.trabajador || `${worker.apePaterno || ''} ${worker.apeMaterno || ''}, ${worker.nombres || ''}`}</h6>
                                    <span className="text-muted">DNI: {worker.numdoc || '—'} · Código SGH: {worker.codSghh || '—'}</span>
                                </div>
                                <span className="badge text-bg-secondary">{worker.tipoTrabajador || '—'}</span>
                            </div>

                            {worker.relojes?.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="table table-sm table-striped table-bordered mb-0">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Reloj</th>
                                                <th>Serial</th>
                                                <th>Línea</th>
                                                <th>Conexión</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {worker.relojes.map((clock, clockIndex) => {
                                                const connected = String(clock.statusConexion) === '1';
                                                return (
                                                    <tr key={clock.id_personaReloj || clockIndex}>
                                                        <td>{clock.descripcion || '—'}</td>
                                                        <td>{clock.serial || '—'}</td>
                                                        <td>{clock.linea || '—'}</td>
                                                        <td>
                                                            <span className={`badge ${connected ? 'text-bg-success' : 'text-bg-secondary'}`}>
                                                                {connected ? 'Conectado' : 'Desconectado'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-muted">Sin relojes registrados.</div>
                            )}
                                </div>
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkerClockSearch;